import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField } from '@mui/material';
import Form, { useForm } from '../../../../components/useForm';
import MedicationDropdown from '../../../Medication/MedicationDropdown';
import ServiceButtonWithToast from '../../../_common/ServiceButtonWithToast';
import { useApiClient } from '../../../../context/ApiClientContext';

const initialFieldValues = {
  medicationId: '',
  medicationNameOverride: '',
};

export default function AddMedicationToNarrativeForm(props) {
  const { onSuccess, actionListId } = props;

  const apiClient = useApiClient();

  const {
    values,
    errors,
    setErrors,
    handleInputChange,
  } = useForm(initialFieldValues);

  const isValidInput = () => {
    const errorMsg = {};
    errorMsg.medication = values.medicationId === '' ? 'Please select a medication.' : '';
    setErrors({ ...errorMsg });
    return Object.values(errorMsg).every((item) => item === '');
  };

  const handleButtonClick = () => {
    if (isValidInput()) {
      return apiClient.addMedicationToNarrative(
        actionListId,
        values.medicationId,
        values.medicationNameOverride,
      );
    }
    return null;
  };

  return (
    <Form>
      <Grid container>
        <Grid item xs={10}>
          <MedicationDropdown
            label="Select a Medication"
            name="medicationId"
            value={values.medicationId}
            onChange={handleInputChange}
            error={errors.medication}
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            label="Brand name to display to patient and clinician"
            variant="outlined"
            fullWidth
            name="medicationNameOverride"
            value={values.medicationNameOverride}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <ServiceButtonWithToast
            service={handleButtonClick}
            onSuccess={onSuccess}
            buttonText="Add"
            successMsg="Success"
          />
        </Grid>
      </Grid>
    </Form>
  );
}

AddMedicationToNarrativeForm.propTypes = {
  onSuccess: PropTypes.func,
  actionListId: PropTypes.number.isRequired,
};

AddMedicationToNarrativeForm.defaultProps = {
  onSuccess: null,
};
